import { render, staticRenderFns } from "./ImportantInfo.vue?vue&type=template&id=95a12c20"
import script from "./ImportantInfo.vue?vue&type=script&lang=js"
export * from "./ImportantInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports